// Set right before a hard redirect that must not raise the browser's "Leave site?" prompt:
// the session is already gone, or the navigation already passed the route leave guards.
let unloadAllowed = false;

export const allowUnload = () => {
  unloadAllowed = true;
};

export const isUnloadAllowed = () => unloadAllowed;
